import { render, staticRenderFns } from "./relatorio-fonte-pagadora.vue?vue&type=template&id=79418196&scoped=true"
import script from "./relatorio-fonte-pagadora.vue?vue&type=script&lang=ts"
export * from "./relatorio-fonte-pagadora.vue?vue&type=script&lang=ts"
import style0 from "./relatorio-fonte-pagadora.vue?vue&type=style&index=0&id=79418196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79418196",
  null
  
)

export default component.exports